exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-42dc147c] .el-input-number--small{width:280px!important}[data-v-42dc147c] .el-input.is-disabled .el-input__inner{color:#000}", ""]);

// exports
